import SittingCom from "../components/SittingCom";

function Sitting(){

    return(
        <div>
            <div className="zzz d-inline-block">
                <h2 className="m-0">اعدادات النظام</h2>
            </div>
            <div>
                <SittingCom/>
            </div>
        </div>
    )
}

export default Sitting;